import * as React from 'react';

import { useToastStore } from '../../stores/use-toast-store';

import { ToastStacks } from './toast-stacks';

type Props = { children: React.ReactNode };

export const ToastNotificationProvider: React.FC<Props> = ({
  children,
}: Props) => {
  const notifications = useToastStore((s) => s.notifications);
  const remove = useToastStore((s) => s.remove);

  React.useEffect(() => {
    if (notifications.length === 0) return;
    const timers = notifications
      .filter((n) => (n.durationMs ?? 4000) !== Infinity)
      .map((n) =>
        setTimeout(() => {
          remove(n.id);
        }, n.durationMs ?? 4000),
      );
    return () => {
      timers.forEach(clearTimeout);
    };
  }, [notifications, remove]);

  return (
    <>
      {children}
      <ToastStacks notifications={notifications} onRemove={remove} />
    </>
  );
};

export default ToastNotificationProvider;
